<!-- <app-relatorio-vendas-filtro [filtros]="filtros"></app-relatorio-vendas-filtro> -->
<app-barra-consulta *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()" [exibirNovo]="false"
  [detalhe]="false">
</app-barra-consulta>
<app-loading [exibir]="carregando"></app-loading>



<div class="conteudo" *ngIf="!carregando">
  <!-- <div name="divFiltro" class="menuTipoGrid" *ngIf="!carregando">
    <div class="row">
      <div class="col col-lg-4 box-individual">
        <div class="dropdown">
          <label>Filtrar Produto</label>
          <select class="form-control form-control-sm" type="text" placeholder="Filtrar Produto..." [(ngModel)]="Modelo"
            (change)="filtrarModelos($event.target.value)">
            <option value="TODOS">TODOS</option>
            <option *ngFor="let familia of dadosFamilia" [value]="familia.nome">{{familia.nome}}</option>
          </select>
        </div>
      </div>
      <div class="col">
        <button class="btn btn-outline-secondary btn-sm mt-4 mr-1 float-right" (click)="exportarExcel()">
          <i class="fa fa-download fa-xs"></i>
          Export Excel
        </button>
      </div>
    </div>
  </div> -->
  <!-- <p-treeTable [value]="data" [columns]="cols" [frozenColumns]="frozenCols" [scrollable]="true" scrollHeight="200px" frozenWidth="200px">
    <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
            <col *ngFor="let col of columns" style="width:250px">
        </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns">
                {{col.header}}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData="rowData" let-columns="columns">
        <tr>
            <td *ngFor="let col of columns; let i = index">
                {{rowData[col.field]}}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="frozenbody" let-rowNode let-rowData="rowData">
        <tr>
            <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                {{rowData.name}}
            </td>
        </tr>
    </ng-template>
</p-treeTable> -->

  <div class="table-scroll">
    <div class="table-size">
      <p-treeTable [value]="data" [columns]="cols" class="style" [frozenColumns]="frozenCols" frozenWidth="200px"
        styleClass="p-treetable-sm">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let header of headers" [attr.colspan]="header.colspan" [ngStyle]="{'width': header.width}">
              {{header.header}}</th>
          </tr>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.field == 'nome'" [ngClass]="'frozenColumnHeader'">
                {{col.header}}
              </th>
              <th *ngIf="col.field != 'nome'" [ngStyle]="{'color': col.color, 'width': col.width}"
                [ttSortableColumn]="col.field">
                {{col.header}}
                <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
          <tr [ttContextMenuRow]="rowNode">
            <ng-container *ngFor="let col of columns; let i = index">
              <td *ngIf="col.field == 'nome'" [ngClass]="'frozenColumn'">
                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                {{col.type ? col.type.transform(rowData[col.field], col.arg1) :
                  rowData[col.field]}}
              </td>
              <td *ngIf="col.field != 'nome'">
                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                {{col.type ? col.type.transform(rowData[col.field], col.arg1) :
                  rowData[col.field]}}
              </td>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="frozenbody" let-rowNode let-rowData="rowData">
          <tr style="height: 57px">
            <td>
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              {{rowData.nome}}
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  </div>
</div>